<template>
  <div class="card w-full">
    <card-header :title="'Orden #' + order.id">
      <template #badge>
        <status-badge status="ready_for_delivery" />
      </template>
    </card-header>

    <p class="text-xs text-content-400">
      Última actualización: {{ formatDatetime(order.updated_at) }}
    </p>

    <div class="detail-grid mt-2">
      <detail-field label="Cliente">
        <router-link
          :to="{
            name: 'clientsDetail',
            params: { id: order.client.id },
          }"
          class="underline system-button"
          >{{ order.client.name }} {{ order.client.last_name }}</router-link
        >
      </detail-field>

      <detail-field v-if="order.diet && order.diet.pet" label="Mascota">
        <router-link
          :to="{
            name: 'petsDetail',
            params: { id: order.diet.pet.id },
          }"
          class="underline system-button"
          >{{ order.diet.pet.name }}</router-link
        >
      </detail-field>

      <detail-field label="Fecha de entrega programada" :value="formatDate(order.min_delivery_date)" />

      <detail-field
        v-if="order.delivery_date"
        label="Fecha de entrega realizada"
        :value="formatDatetime(order.delivery_date)"
      />

      <detail-field label="Semanas" :value="order.weeks" />

      <detail-field label="Método de entrega" :value="order.pickup_delivery ? 'Pick-Up' : 'Envío'" />
    </div>

    <div v-if="order.address && !order.pickup_delivery" class="mt-2 text-sm">
      <p class="detail-label">Dirección</p>
      <address-component
        :address="order.address"
        :showShippingPrice="true"
        :branchId="order.branch_id"
      />
    </div>

    <branch-component class="mt-2" :branch="order.branch" />

    <div
      class="mt-2 text-sm"
      v-if="
        !order.pickup_delivery &&
        order.related_shipment_orders &&
        order.related_shipment_orders.length > 0
      "
    >
      <p class="font-medium">
        Esta orden debe enviarse con las siguientes órdenes:
      </p>
      <div class="flex space-x-2">
        <p
          v-for="relatedOrder in order.related_shipment_orders"
          :key="relatedOrder.id"
          class="text-sm text-content-400"
        >
          #{{ relatedOrder.id }}
        </p>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import OptionsMenu from "../ui/OptionsMenu";
import AddressComponent from "../ui/Address";
import BranchComponent from "../ui/Branch";
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Ready For Delivery",

  components: {
    OptionsMenu,
    AddressComponent,
    BranchComponent,
  },

  props: {
    order: Object,
  },

  methods: {
    formatDate,

    formatDatetime,

    getOptions(order) {
      let options = [{ action: "pickup", label: "Recoger en sucursal" }];

      if (
        !order.pickup_delivery &&
        order.related_shipment_orders &&
        order.related_shipment_orders.length > 0
      ) {
        options.push({
          action: "separate",
          label: "Enviar orden por separado",
        });
      }

      return options;
    },
  },
};
</script>